/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_File_Statistics_EmbeddedInputs */



/**
* | output |
* | --- |
* | "Files Embedded" |
*
* @param {Spaces_File_Statistics_EmbeddedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_file_statistics_embedded = /** @type {((inputs?: Spaces_File_Statistics_EmbeddedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_File_Statistics_EmbeddedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eingebettete Dateien")
	return /** @type {LocalizedString} */ ("Files Embedded")
});